import React, { useEffect, useState } from "react";
import logo from "../../../assets/images/logo_v4.svg";
import ProviderImg from "../../../assets/images/defaultUserMOP.svg";
import FemaleDrImage from "../../../assets/images/female-dr-avatar.webp";
import MaleDrImage from "../../../assets/images/male_dr_avatar.webp";
import UserProfile from "../../../assets/images/defaultuser.webp";

const Image = ({
  className = "",
  src,
  type = "default",
  alt = "",
  gender,
  style,
  local = false,
  ...attributes
}) => {
  const getDefaultImage = () => {
    if (type === "provider") {
      return gender === "MALE"
        ? MaleDrImage
        : gender === "FEMALE"
        ? FemaleDrImage
        : ProviderImg;
    }
    if (type === "user") {
      return UserProfile;
    }
    return attributes.profileType === "profile" ? "" : logo;
  };

  const [images, setImages] = useState([]);
  const [svgContent, setSvgContent] = useState(null);
  const [isSvg, setIsSvg] = useState(false);

  const getImage = async (id) => {
    try {
      if (!local) {
        //   const result = await axios.get(`/v1/s3/signed/url?fileName=${id}`);
        //   if (result?.data?.url) {
        //     return result.data.url;
        //   }
        const contentPath = id.substring(id.indexOf("/contents"));
        const newUrl =
          process.env.REACT_APP_PROVIDER_IMAGE_CDN_URL + contentPath;
        return newUrl;
      }
      return src;
    } catch (err) {
      return src;
    }
  };

  const getImages = async () => {
    const imageSrc = (src && (await getImage(src))) || getDefaultImage();
    if (imageSrc.endsWith(".svg") && local) {
      try {
        const response = await fetch(imageSrc);
        const svgText = await response.text();
        setSvgContent(svgText);
        setIsSvg(true);
      } catch (err) {
        setImages([imageSrc]);
        setIsSvg(false);
      }
    } else {
      setImages([imageSrc]);
      setIsSvg(false);
    }
  };

  useEffect(() => {
    getImages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src, type]);

  if (isSvg && svgContent) {
    const svgStyle = {
      ...style,
      width: "42px !important",
      height: "42px !important",
    };
    return (
      <div
        className={className}
        style={svgStyle}
        dangerouslySetInnerHTML={{ __html: svgContent }}
        {...attributes}
      />
    );
  }

  return images.map((img, i) => (
    <img
      src={img}
      alt={alt || `mop-img-${i}`}
      key={i}
      className={className}
      style={style}
      loading="lazy"
      {...attributes}
      onError={() => setImages([getDefaultImage(type)])}
    />
  ));
};

export default Image;
